import { ReactNode } from 'react';
import styled from 'styled-components';
import { Badge } from '../../dtos';
import { useRouter } from 'next/router';
import GiftIcon from '../../../../new-components/svg-icons/GiftIcon';

interface CardBadgesProps {
  badges: Badge[];
  hasOffer: boolean;
}

interface BadgeProps {
  badge: Badge;
  icon?: ReactNode | JSX.Element;
}
const BadgeChip = ({ badge, icon }: BadgeProps) => {
  return (
    <BadgeContainer>
      {icon && icon}
      {badge.name}
    </BadgeContainer>
  );
};

const CardBadges = ({ badges, hasOffer }: CardBadgesProps) => {
  const { locale } = useRouter();

  return (
    <Container className="hide-scrollbar">
      {hasOffer && (
        <BadgeChip
          badge={{
            id: 0,
            name: locale == 'en' ? 'Offer Included' : 'عرض متاح'
          }}
          icon={<GiftIcon />}
        />
      )}
      {badges?.map(badge => (
        <BadgeChip key={`${badge.id} ${badge.name}`} badge={badge} />
      ))}
    </Container>
  );
};

const BadgeContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  background: #f7f9fd;
  padding: 4px 8px;
  border-radius: 360px;
  height: 30px;
  font-size: 14px;
  color: #1a2028;
  font-family: materialRegular;
  white-space: nowrap;

  @media (max-width: ${props => props.theme.breakPoints.mobile.max}) {
    font-size: 11px;
  }
`;

const Container = styled.div`
  width: 100%;
  display: flex;
  gap: 8px;
  overflow-x: auto;
`;

export default CardBadges;
